import type { Category, Post } from '@/payload-types'

import { CATEGORY_BADGE_FALLBACK_COLORS } from '@/lib/brandColors'

export { CATEGORY_BADGE_FALLBACK_COLORS } from '@/lib/brandColors'

const HEX_COLOR_PATTERN = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/

export function normalizeCategoryColor(color?: string | null): string | undefined {
  if (!color?.trim()) return undefined

  const normalized = color.trim()

  if (!HEX_COLOR_PATTERN.test(normalized)) {
    return undefined
  }

  return normalized
}

export function getCategoryColorFromCategories(
  categories: Post['categories'],
  colorByTitle: Record<string, string> = {},
): string | undefined {
  if (!categories || !Array.isArray(categories) || categories.length === 0) {
    return undefined
  }

  const first = categories[0]

  if (typeof first === 'object' && first !== null) {
    const category = first as Category
    const populatedColor = normalizeCategoryColor(category.color)

    if (populatedColor) {
      return populatedColor
    }

    if (category.title && colorByTitle[category.title]) {
      return colorByTitle[category.title]
    }
  }

  return undefined
}

export function getCategoryBadgeColor(
  title: string | undefined,
  index: number,
  colorByTitle: Record<string, string>,
): string {
  if (title && colorByTitle[title]) {
    return colorByTitle[title]
  }

  return CATEGORY_BADGE_FALLBACK_COLORS[index % CATEGORY_BADGE_FALLBACK_COLORS.length]
}
